<script>
  import { onMount } from "svelte";
  import { renderToCanvas } from "bitframes";
  import { colorSpace } from "../util/constants";

  export let hd = false;
  export let zoom = false;
  export let encoding = null;
  export let width = 256;
  export let height = 256;

  let canvas, context;

  let _oldEncoding;
  $: {
    if (_oldEncoding !== encoding) {
      _oldEncoding = encoding;
      drawFrame();
    }
  }

  onMount(() => {
    context = canvas.getContext("2d", { colorSpace });
    drawFrame();
    return () => {};
  });

  function drawFrame() {
    if (!context || !encoding) return;
    renderToCanvas({
      colorSpace,
      width,
      height,
      encoding,
      context,
      margin: zoom ? 0 : undefined,
      hatch: Boolean(hd),
      hatchContours: Boolean(hd),
    });
  }
</script>

<canvas bind:this={canvas} {width} {height}></canvas>

<style>
  canvas {
    image-rendering: pixelated;
    width: 100%;
    height: 100%;
  }
</style>
